import { action, computed, makeObservable, observable } from 'mobx'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { Cubit } from './core'
import { PromptType } from '../firestore/PromptVersion/types'
import { PromptRubricType } from '../models/PromptRubricType'
import { PromptInteractiveElementType } from '../models/PromptInteractiveElementType'
import { PromptPostRoomStateType } from '../models/PromptPostRoomStateType'
import { getRoomPromptTypes } from '../firestore/PromptRubricType'
import { type StaticModelCollection } from '../types'
import { getPromptPostRoomStateTypes } from '../firestore/PromptPostRoomStateType'
import { getPromptInteractiveElementTypes } from '../firestore/PromptInteractiveElementType'

export class AdminPromptsCubit extends Cubit {
  repository: FirebaseRepository

  @observable tab: PromptType

  private _rubric: StaticModelCollection<PromptRubricType>
  private _postRoomState: StaticModelCollection<PromptPostRoomStateType>
  private _interactiveElement: StaticModelCollection<PromptInteractiveElementType>

  constructor(repository: FirebaseRepository) {
    super()
    makeObservable(this)
    this.repository = repository
    this._rubric = PromptRubricType.emptyCollection(repository)
    this._postRoomState = PromptPostRoomStateType.emptyCollection(repository)
    this._interactiveElement =
      PromptInteractiveElementType.emptyCollection(repository)
    this.tab = PromptType.rubric
  }

  initialize(): void {}

  @computed
  get rubric() {
    this.startStreamForType(PromptType.rubric)
    return this._rubric
  }

  @computed
  get postRoomState() {
    this.startStreamForType(PromptType.postRoomState)
    return this._postRoomState
  }

  @computed
  get interactiveElement() {
    this.startStreamForType(PromptType.interactiveElement)
    return this._interactiveElement
  }

  @action
  changeTab(tab: typeof this.tab): void {
    this.tab = tab
  }

  @action
  private startStreamForType(type: PromptType) {
    if (this.hasStream(type)) return
    switch (type) {
      case PromptType.rubric:
        return this.addStream(getRoomPromptTypes(this.repository), (m) =>
          this._rubric.replaceModels(m)
        )
      case PromptType.postRoomState:
        return this.addStream(
          getPromptPostRoomStateTypes(this.repository),
          (m) => this._postRoomState.replaceModels(m)
        )
      case PromptType.interactiveElement:
        return this.addStream(
          getPromptInteractiveElementTypes(this.repository),
          (m) => this._interactiveElement.replaceModels(m)
        )
    }
  }
}
